import { sideNavigationReducer } from './sideNavigationReducer';
import { userReducer } from './userReducer';
import { combineReducers } from 'redux';


export const allReducers = combineReducers({
    userInfo: userReducer,
    sideNavigation: sideNavigationReducer
})